module.exports = __webpack_public_path__ + "img/flagSenegal.1fe348e9.png";